var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 249,
    viewBox: "0 0 108 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 184L108 0L0 0L0 184H108Z",
    fill: "#90981E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 207V196H0V207H108Z",
    fill: "#90981E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108 228V217H0V228H108Z",
    fill: "#90981E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108 249V238H0V249H108Z",
    fill: "#90981E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenline);
export default __webpack_public_path__ + "static/media/greenline.6ed57aa07fd19bd99044b2740c6ac2ef.svg";
export { ForwardRef as ReactComponent };